var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5833 0.556641H3.03734C1.86532 0.556641 0.911133 1.48652 0.911133 2.63154V27.2819C0.911133 28.4296 1.86532 29.3613 3.03734 29.3613H27.5851C28.7598 29.3613 29.7167 28.4296 29.7167 27.2819V2.63154C29.7167 1.48652 28.7598 0.556641 27.5833 0.556641Z",
    fill: "#0177B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18296 11.355H9.46329V25.1006H5.18296V11.355ZM7.31997 4.51367C8.68554 4.51367 9.79545 5.62359 9.79545 6.98915C9.79545 8.35471 8.68554 9.46733 7.32087 9.46733C6.66398 9.4659 6.03438 9.20438 5.56979 8.73997C5.10521 8.27555 4.84346 7.64605 4.8418 6.98915C4.8418 6.66384 4.90592 6.34172 5.03049 6.0412C5.15506 5.74069 5.33765 5.46767 5.5678 5.23777C5.79796 5.00786 6.07117 4.82558 6.37182 4.70133C6.67247 4.57709 6.99466 4.51332 7.31997 4.51367ZM12.1359 11.355H16.2335V13.2337H16.2902C16.8609 12.1534 18.2544 11.0138 20.341 11.0138C24.6672 11.0138 25.4657 13.8611 25.4657 17.5617V25.1015H21.1962V18.4151C21.1962 16.8217 21.1673 14.7694 18.9763 14.7694C16.7529 14.7694 16.4108 16.5067 16.4108 18.298V25.0979H12.1422V11.3523L12.1359 11.355Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8056,
    height: 28.8056,
    fill: "white",
    transform: "translate(0.911133 0.555664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.6f8697754a4624e0688392a435a3f51d.svg";
export { ForwardRef as ReactComponent };